import isMicrosoft from "./isMicrosoft";
import isDeloitte from "./isDeloitte";
import getDepartmentLabel from "./getDepartmentLabel";

const settingDepartmentOption = (organizationName: string) => {
  if (isMicrosoft(organizationName)) {
    return createSettingOption("/admin/departments", getDepartmentLabel(organizationName, false));
  } if (isDeloitte(organizationName)) {
    return createSettingOption("/admin/departments", getDepartmentLabel(organizationName, false));
  }
  return createSettingOption("/admin/departments", getDepartmentLabel(organizationName, false));
};

const createSettingOption = (to: string, phrase: string) => ({ to, phrase });

export default settingDepartmentOption;
